import { Injectable } from "@angular/core";
import { Http, Headers, Response, RequestOptions } from "@angular/http";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/of";
import { AuthenticationService } from "../../authentication.service";
import { EnvironmentService } from "../../index";
import { Dealer } from "app/_models/dealer";
import { KmCatchUpAgreement } from "app/_models/kmCatchUpAgreement";

@Injectable()
export class KmCatchUpAgreementService {
  private baseUrl: string =
    this.environmentService.getBaseURL() +
    "/api" +
    "/matrix/products/km-catch-up/agreements";

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService
  ) {}

  getByDealer(dealer_id: string): Observable<KmCatchUpAgreement[]> {
    let agreement$ = this.http
      .get(`${this.baseUrl}/dealer/${dealer_id}?status=true`, this.makeHeaders())
      .map(mapAgreements)
      .catch((error: any) => {
        // Handle 404 (no agreements found) gracefully
        if (error.status === 404) {
          console.log('No km-catch-up agreements found for dealer:', dealer_id);
          return Observable.of([]); // Return empty array instead of error
        }
        // For other errors, use the standard error handling
        return handleError(error);
      });
    return agreement$;
  }

  get(id: string): Observable<KmCatchUpAgreement> {
    let agreement$ = this.http
      .get(`${this.baseUrl}/${id}`, this.makeHeaders())
      .map(mapAgreement)
      .catch(handleError);
    return agreement$;
  }

  create(agreement: Partial<KmCatchUpAgreement>, payMonths?: number): Observable<KmCatchUpAgreement> {
    const segmentId = 3;
    const url = payMonths ? `${this.baseUrl}?payMonths=${payMonths}` : this.baseUrl;
    let newAgreement = this.http
      .post(
        url,
        JSON.stringify({ segmentId, agreement }),
        this.makeHeaders()
      )
      .map(mapAgreement)
      .catch(handleErrorAgreement);

    return newAgreement;
  }

  update(agreement: Partial<KmCatchUpAgreement>, payMonths?: number): Observable<KmCatchUpAgreement> {
    const url = payMonths ? 
      `${this.baseUrl}/${agreement._id}?payMonths=${payMonths}` : 
      `${this.baseUrl}/${agreement._id}`;
    return this.http.put(
      url,
      JSON.stringify({agreement}),
      this.makeHeaders()
    )
    .map(mapAgreement)
    .catch(handleErrorAgreement);
  }

  delete(id: string): Observable<Response> {
    return this.http
      .delete(`${this.baseUrl}/${id}`, this.makeHeaders())
      .map((res: Response) => res.json())
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      );
  }

  acceptAgreement(
    agreement: Partial<KmCatchUpAgreement>,
    dealer: Dealer,
    regnr: string,
    mauticId: string
  ): Observable<Response> {
    return this.http
      .put(
        `${this.baseUrl}/${agreement._id}/accept-agreement?dealer=${dealer._id}&regnr=${regnr}&mauticId=${mauticId}`,
        this.makeHeaders()
      )
      .map((res: Response) => res.json())
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      );
  }

  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("Content-Type", "application/json ");
    headers.append("charset", "UTF-8 ");
    headers.append("Accept", "application/json ");

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}

function toAgreement(r: any): KmCatchUpAgreement {
    return r as KmCatchUpAgreement;
}

function mapAgreement(response: Response): KmCatchUpAgreement {
  return toAgreement(response.json());
}

function mapAgreements(response: Response): KmCatchUpAgreement[] {
  return response.json().map(toAgreement);
}

function handleError(error: any) {
  let errorMsg =
    error.message ||
    `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`;
  console.error(errorMsg);

  return Observable.throw(errorMsg);
}

function handleErrorAgreement(error: any) {
  let errorMsg =
  "Noget gik galt ved generering af en kilometer indhentning aftale";
  alert(errorMsg)
  return Observable.throw(error);
} 


// WEBPACK FOOTER //
// ./src/app/_services/matrix/products/km-catch-up-agreement.service.ts